import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M14.3 7.355c3.133-.691 8.792 2.463 9.638 3.355s.923 2.228.584 3.881c-.136.668 1.71.056 1.739 2.015.019 1.273-.288 4.813-2.038 6.481-1.75 1.67-4.281 3.43-7.298 2.434-1.774-.586 1.067-2.121-.407-2.862s-4.693.362-7.762-1.096c-.597-.283-.638-1.082-1.498-2.291-.305-.429-1.143-.558-1.262-1.11s1.087-2.04.544-2.793c-2.011-2.79-2.98-4.774-2.354-4.986s2.691 2.725 4.312 2.914c1.31.152 2.484-.725 2.79-1.104 1.68-2.076-.122-4.147 3.011-4.838",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAta = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAta_default = SvgFlagAta;

export { FlagAta_default as default };
